/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { District } from './district';
import { Province } from './province';
import { SubDistrict } from './subDistrict';

export interface BranchRequestDto {
  id: string;
  type: BranchRequestDto.TypeEnum;
  /**
   * 2021-10-01
   */
  registerDate: string;
  name: string;
  branchName: string;
  /**
   * 2021-10-01
   */
  contractStartDate: string;
  /**
   * 2021-10-01
   */
  contractEndDate: string;
  remark: string;
  imageUrl: string;
  address: string;
  province: Province;
  district: District;
  subDistrict: SubDistrict;
  zipCode: string;
  email: string;
  isActive: boolean;
  franchiseTierId: string;
}
// tslint:disable-next-line:no-namespace
export namespace BranchRequestDto {
  export type TypeEnum = 'franchise' | 'wpn';
  export const TypeEnum = {
      Franchise: 'franchise' as TypeEnum,
      Wpn: 'wpn' as TypeEnum,
  };
}
